import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import global from 'global';
import { isServer } from 'env/ssr/ServerSideRenderManager';

@withTranslation()
@inject('appStore', 'authStore')
@observer
class MobxApp extends Component {
  componentDidMount() {
    const { t, appStore, authStore } = this.props;
    global.t = t;

    if (
      process.env.LOCAL_BUILD !== 'true' &&
      process.env.NODE_ENV === 'production'
    ) {
      if (!isServer && window.location.host.indexOf('nexudus.site') > -1) {
        authStore.setRegistrableDomain('nexudus.site');
      } else if (!isServer && window.location.host.indexOf('vercel') > -1) {
        //Do not set registrable domain as this URL is a vercel previews
      } else {
        authStore.setRegistrableDomain(
          appStore.configuration['System.RegistrableDomain']
        );
      }
    }
  }

  render() {
    return (
      <div className="nx" id={`business-${this.props.appStore.business?.Id}`}>
        {this.props.children}
      </div>
    );
  }
}

export default MobxApp;
